WiseMetering.Views.NewWiseApiIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/wise_api/new',
    title: () => i18next.t('modal.title.integrations.new'),
    ui: {
        configurations: '#integration_configuration_id',
        sites: '#integration_site_id'
    },

    onShow: function() {
        const
            configurations = WiseMetering.utils.optionsFromModels(this.options.license.configurations().models, 'name'),
            sites = WiseMetering.utils.optionsFromModels(WiseMetering.zones.activeSites().models, 'name');

        this.ui.configurations.html(configurations);
        this.ui.sites.html(sites);
    },

    getFormData: function() {
        const data = this.formSerializer();

        data.partner_id = this.options.license.get('partner_id');

        // The name is derived server side from "configuration — site".
        if (!data.name) {
            delete data.name;
        }

        return data;
    }
});
